/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import Video from "../VideoChat";
import Chat from "../../Pages/Chat";
import {servicesChat, servicesVirtual} from "../../Constants/serviceType";

const ChatContainer = (
    {
        data,
        over = false,
        close = false,
        handleChatData,
        handleCloseTranscript,
        isVet = false,
        isTranscript = false,
        isJoin,
        setVideoChatIsClosed,
        videoChatIsClosed
    }: {
        data: any,
        over?: boolean,
        close?: boolean,
        handleChatData?: (open, data, over) => void,
        handleCloseTranscript?: () => void,
        isVet?: boolean,
        isTranscript?: boolean,
        isJoin?: string,
        videoChatIsClosed?: null | string,
        setVideoChatIsClosed?: (string) => void,
    }) => {
    const {item = {}, vetProfile = {}} = data?.data || {item: {}};
    const type = item?.type;
    const appointmentId = data?.data?.item ? data.data.item.id : 1;
    return (
        <>
            {servicesChat.includes(type)
            &&
            <Chat closeChat={handleChatData} closeTranscript={handleCloseTranscript} data={item} vet={vetProfile}
                over={over} appointmentId={appointmentId} isVet={isVet} isTranscript={isTranscript} isJoin={isJoin}
                chatClosed={videoChatIsClosed}
            />
            }
            {servicesVirtual.includes(type)
            &&
            <Video closeChat={handleChatData} data={item} vet={vetProfile} appointmentId={appointmentId} isVet={isVet}
                isTranscript={isTranscript} over={over} closeTranscript={handleCloseTranscript} isJoin={isJoin}
                setVideoChatIsClosed={setVideoChatIsClosed} videoChatIsClosed={videoChatIsClosed}
            />
            }
        </>
    );
};

ChatContainer.propTypes =
    {
        data: PropTypes.object
    };

ChatContainer.defaultProps =
    {
        data: {
            data: {
                item: {},
                vetProfile: {}
            }
        }
    };


export default ChatContainer;
